import React, { FC, useEffect, useState } from "react";
import Container from "saur_ui_library/src/Atoms/Container/Container";
import ModalFlexible from "saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { dataParam } from "../utils/helpers/observer";
import { LocalStorage } from "../utils/localStorage";
import FormBreak from "./ecpParameter/FormBreak";
import FormSeason from "./ecpParameter/FormSeason";
import FormFlow from "./ecpParameter/FormFlow";
import { Provider } from "react-redux";
import ecpStore from "../redux/ecpStore";
import { getTheme } from "saur_ui_library/src/BrandsConfig";
import FormOverFlow from "./ecpParameter/FormOverFlow";
import { renderSwitchButtons } from "../utils/helpers/view/detailsHelper";
import { TabProps } from "../utils/Interface";

type SeuilProps = {
  IsVisible: any;
};
const SeuilParam: FC<SeuilProps> = (IsVisible) => {
  const [modalVisible, setModalVisible] = useState<any>(IsVisible);
  const [paramName, setParamName] = useState("");
  const [code, setCode] = useState(window.sessionStorage.getItem("Code"));

  // Gestion des onglets avec un seul state
  const [tabsStates, setTabsStates] = useState<TabProps[]>([
    { id: 0, label: "Seuils", active: true },
    { id: 1, label: "Saisonnalité", active: false },
    { id: 2, label: "Débit des pompes", active: false },
    { id: 3, label: "Débordement", active: false },
  ]);

  useEffect(() => {
    const localName = LocalStorage.prName.get();
    if (localName !== null) {
      setParamName(localName.toString());
    }
    setCode(window.sessionStorage.getItem("Code"));
  }, []);

  // Classes dynamiques basées sur les onglets actifs
  const classnameSeuil = `${
    tabsStates[0].active ? "seuilContainer" : "hide-seuilContainer"
  }`;
  const classnameSeason = `${
    tabsStates[1].active ? "seasonContainer" : "hide-seasonContainer"
  }`;
  const classnameDebit = `${tabsStates[2].active ? "flowContainer" : "hide-flowContainer"}`;
  const classnameDebordement = `${
    tabsStates[3].active ? "overFlowContainer" : "hide-overFlowContainer"
  }`;

  const popupContent = () => (
    <Container className="seuilContentContainer">
      <Container className="filtre">
        {renderSwitchButtons(tabsStates, setTabsStates)}
      </Container>
      {tabsStates[0].active ? (
        <Container className={classnameSeuil}>
          <FormBreak
            id="form-seuil"
            token={LocalStorage.token.get() as string}
            mainInstallCode={code as string}
          />
        </Container>
      ) : null}
      {tabsStates[1].active ? (
        <Container className={classnameSeason}>
          <Provider store={ecpStore}>
            <ThemeProvider theme={getTheme("saur")}>
              <FormSeason
                id="form-season"
                token={LocalStorage.token.get() as string}
                mainInstallCode={code as string}
              />
            </ThemeProvider>
          </Provider>
        </Container>
      ) : null}
      {tabsStates[2].active ? (
        <Container className={classnameDebit}>
          <FormFlow
            id="form-flow"
            token={LocalStorage.token.get() as string}
            mainInstallCode={code as string}
          />
        </Container>
      ) : null}
      {tabsStates[3].active ? (
        <Container className={classnameDebordement}>
          <FormOverFlow
            id="form-overFlow"
            mainInstallCode={code as string}
          />
        </Container>
      ) : null}
    </Container>
  );

  return (
    <Container className="sds-reset-style seuilparameterClass">
      <Styles />
      <ModalFlexible
        showHeader
        title={paramName}
        toggleModal={() => {
          setModalVisible(!IsVisible);
          dataParam.newState(false);
        }}
        visible={modalVisible}
        desktopContent={popupContent}
      />
    </Container>
  );
};
const Styles = createGlobalStyle`
.sds-reset-style {
.seuilparameterClass{
  margin-left:auto;   
  margin-right: auto;
  margin-top: 2%;
  margin-bottom: 1%;
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position {
    min-width: 55%;
    width: auto;
  }
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position .modal-flex-desktop-content .modal-flex-desktop-header {
    align-items: flex-end !important;
    flex-direction: column !important;
    width: 60px !important;
    align-items: flex-end !important;
    padding: 0px !important;
    height: max-content;
  }
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position .modal-flex-desktop-content .modal-flex-desktop-scrollable {
    height: 100vh !important;
  }
  .modal-flex-desktop-header {
    display: flex;
    justify-content: end;
    padding: 0px;
  }
  .filtre{
    width:100%;
    margin-bottom: 2%;
  .FilterSelect{
    width:80vh;
    align-self:center;
    margin-bottom: 15px;
    .filter-animate-content{
      background-color: #008BD2
    }
    .filter-button{
      background-color: #F5F8FB;
    }
  }
}
  .hide-seuilContainer,.hide-seasonContainer{
    display:none
  }
}
}
`;
export default SeuilParam;
